import React, { Suspense, lazy } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Badge, Button, Card, PageHeader } from '../../Components/ui';
import { resolveCabinetsIndexAccess } from '../access';
import { ROLES, ROLE_ORDER, SUPER_ADMIN, cabinetPath, rolePages } from '../config';
import { InfoNote } from './parts';
import '../cabinet.css';

// Test akkauntlarni yaratish bloki — faqat development. Production build'da shart false bo'ladi
// va import (panel hamda add-staff so'rovi kodi) bundle'ga kirmaydi.
const TestAccountsPanel =
  process.env.NODE_ENV === 'development' ? lazy(() => import('../devtools/TestAccountsPanel')) : null;

// /cabinets — 14 ta rol kabineti (faqat super_admin, sidebar'da yo'q — to'g'ridan-to'g'ri URL orqali).
function CabinetsIndex({ userRole }) {
  const navigate = useNavigate();
  const access = resolveCabinetsIndexAccess(userRole);
  if (access.redirect) return <Navigate to={access.redirect} replace />;

  return (
    <div className="ui-cab-page">
      <PageHeader title="Rollar kabinetlari" subtitle="Xodim rollari uchun kabinetlarni ko'rish rejimida ochish" />
      <InfoNote>
        Ko'rish rejimi faqat ko'rsatish uchun: sizning rolingiz (super_admin) o'zgarmaydi. Kabinetdagi haqiqiy ma'lumotlar
        sizning huquqlaringiz bilan yuklanadi; namuna ma'lumotlar "Namuna" belgisi bilan ko'rsatiladi.
      </InfoNote>
      <div className="ui-cab-roles">
        {ROLE_ORDER.map((code) => {
          const role = ROLES[code];
          return (
            <Card key={code} className="ui-cab-role" padding="md">
              <div className="ui-cab-role__head">
                <h3 className="ui-cab-role__name">{role.name}</h3>
                {role.existing && (
                  <Badge variant="neutral" size="sm">
                    Mavjud rol
                  </Badge>
                )}
              </div>
              <p className="ui-cab-role__desc">{role.description}</p>
              <div className="ui-cab-role__meta">
                <span>
                  <code>{code}</code> · {rolePages(code).length} sahifa
                </span>
                <span className="ui-cab-role__login">
                  <Phone aria-hidden="true" /> {role.testLogin}
                </span>
              </div>
              <Button variant="secondary" rightIcon={<ArrowRight />} onClick={() => navigate(cabinetPath(code))}>
                Ochish
              </Button>
            </Card>
          );
        })}
      </div>
      {TestAccountsPanel && userRole === SUPER_ADMIN && (
        <Suspense fallback={null}>
          <TestAccountsPanel />
        </Suspense>
      )}
    </div>
  );
}

export default CabinetsIndex;
